import { SafeDate } from '@binamik/js-providers'

export const parsePeriods = ({ id, label, initial_date: initialDate, final_date: finalDate }) => ({
  id,
  name: label,
  startDate: new SafeDate(initialDate).toStartOf('day').jsDate,
  endDate: new SafeDate(finalDate).toStartOf('day').jsDate
})
